import { useMutation, gql } from "@apollo/client"
import serializationKeys from "../serializationKeys"
import { JOB_FIELDS } from "./useQueryJobs"

const UPDATE_JOB_MUTATION = gql`
  ${JOB_FIELDS}
  mutation UpdateJob($id: ID!, $title: String, $description: String, $after: Date, $users: [ID!], $groups: [ID!]) {
    updateJob(id: $id, title: $title, description: $description, after: $after, users: $users, groups: $groups) {
      ...JobFields
    }
  }
`
const DELETE_JOB_MUTATION = gql`
  mutation DeleteJob($id: ID!) {
    deleteJob(id: $id)
  }
`

const useMutationUpdateJob = (job) =>
  useMutation(UPDATE_JOB_MUTATION, {
    context: {
      serializationKey: serializationKeys.job(job),
    },
  })

const useMutationDeleteJob = (job) =>
  useMutation(DELETE_JOB_MUTATION, {
    context: {
      serializationKey: serializationKeys.job(job),
    },
  })

export { useMutationUpdateJob, useMutationDeleteJob }
